import React, { useState } from "react";
import FileUpload from "../components/FileUpload";
import HeaderMapping from "../components/HeaderMapping";
import PreviewData from "../components/PreviewData";
import ProcessingSummary from "../components/ProcessingSummary";
import Sidebar from "../components/Sidebar";
import {useParams} from "react-router-dom";

const WIZARD_STEP = {
  UPLOAD: 1,
  MAP_HEADERS: 2,
  PREVIEW: 3,
  SUMMARY: 4,
};

const ExcelImporter = () => {
  const [currentStep, setCurrentStep] = useState(WIZARD_STEP.UPLOAD);
  const [fileData, setFileData] = useState(null);
  const [headerMapping, setHeaderMapping] = useState(null);
  const [batchId, setBatchId] = useState(null);
  const [recordCount, setRecordCount] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState(null);
  const { eventId } = useParams();

  console.log("event Id: "+eventId)
  const handleFileUploaded = (data) => {
    setFileData(data);
    setCurrentStep(WIZARD_STEP.MAP_HEADERS);
    setError(null);
  };

  const handleMappingComplete = (mapping) => {
    setHeaderMapping(mapping);
    setCurrentStep(WIZARD_STEP.PREVIEW);
  };

  const handleContinueToProcess = () => {
    setIsProcessing(true);
    setCurrentStep(WIZARD_STEP.SUMMARY);
  };

  const handleProcessComplete = (id, count) => {
    setBatchId(id);
    setRecordCount(count);
    setIsProcessing(false);
  };

  const handleProcessError = (err) => {
    setError(err);
    setIsProcessing(false);
  };

  const handleStartOver = () => {
    setCurrentStep(WIZARD_STEP.UPLOAD);
    setFileData(null);
    setHeaderMapping(null);
    setBatchId(null);
    setRecordCount(null);
    setError(null);
  };

  const handleBackToMapping = () => {
    setCurrentStep(WIZARD_STEP.MAP_HEADERS);
    setError(null);
  };

  const logout = (e) => {
    e.preventDefault();
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("universityId");
    window.location.href = "/login";
  };

  return (
    <div className="dashboard">
      <Sidebar />
      <main className="main-content">
        <header className="header component">
          <span className="component-header">Import Submissions</span>

        </header>

        <p><a href="/dashboard">Home</a> &gt; Excel Import</p>
        <hr />

        {/* Progress */}
        <div className="flex items-center gap-3 my-4">
          {["Upload", "Map", "Preview", "Process"].map((label, i) => {
            const step = i + 1;
            const isActive = currentStep >= step;
            return (
              <React.Fragment key={label}>
                <div
                  className={`w-8 h-8 flex items-center justify-center rounded-full font-bold ${
                    isActive ? "bg-blue-900 text-white" : "bg-gray-300 text-gray-700"
                  }`}
                >
                  {step}
                </div>
                {i < 3 && <div className="w-10 h-1 bg-gray-300" />}
              </React.Fragment>
            );
          })}
        </div>

        {/* Steps */}
        <div className="bg-white rounded shadow p-4">
          {currentStep === WIZARD_STEP.UPLOAD && (
            <FileUpload onFileUploaded={handleFileUploaded} />
          )}

          {currentStep === WIZARD_STEP.MAP_HEADERS && fileData && (
            <HeaderMapping
              fileData={fileData}
              eventId = {eventId}
              onMappingComplete={handleMappingComplete}
              onBack={handleStartOver}
            />
          )}

          {currentStep === WIZARD_STEP.PREVIEW && fileData && headerMapping && (
            <PreviewData
              fileData={fileData}
              headerMapping={headerMapping}
              onBack={handleBackToMapping}
              onContinue={handleContinueToProcess}
            />
          )}

          {currentStep === WIZARD_STEP.SUMMARY && fileData && headerMapping && (
            <ProcessingSummary
              fileData={fileData}
              headerMapping={headerMapping}
              isProcessing={isProcessing}
              error={error}
              batchId={batchId}
              eventId = {eventId}
              recordCount={recordCount}
              onStartOver={handleStartOver}
              onBackToMapping={handleBackToMapping}
              onProcessComplete={handleProcessComplete}
              onProcessError={handleProcessError}
            />
          )}
        </div>
      </main>
    </div>
  );
};

export default ExcelImporter;